
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import OE_AttendanceAgenda from './OE_AttendanceAgenda';
import OE_CheckinAgenda from './OE_CheckinAgenda';
import OE_EmploymentStatusFinder from './EmploymentStatusFinder';
import OE_MusicianPropositionFinder from './MusicianPropositionFinder';
import OE_PrincipalConfirmationFinder from './PrincipalConfirmationFinder';
import OE_CheckinTerminalAgenda from './OE_CheckinTerminalAgenda';
import OpusPerformanceAgenda from '../OpusManagement/OpusPerformanceAgenda';
import OpusFinder from '../OpusManagement/OpusFinder';
import OrchestraMatrix from '../OrchestraMatrix/OrchestraMatrix';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import WidgetNavigationMap from '../../moreCore/UI/Navigation/WidgetNavigationMap';

/**
 * Home-Navigation für Orchesterdienste-Bereich
 */
class OE_HomeNavigation extends compose(WidgetNavigationMap<{}>) {

    


    private _openOMmatrix() {
        let dlg = new GenericDialog();

        // aus Projectwizard kopiert:
        let form = new OrchestraMatrix();
        form.mainMenuGlobalSpaceNode = dlg.leftActionContainerNode; // hier kommt die OM-toolbar hin
        //form.directProjectId = this.entityId;

        this.UiModder.domStyle.set(form.domNode, {
            height: "800px",
            width: "100%"
        });

        this.UiModder.domStyle.set(dlg.modalDlgContentNode, {
            width: "80%"
        });

        //form.setup(this.entityData, this.bookingList.getEntityListData() as any);

        dlg.show(form,
            this.translations["OM__SchedulerMatrix"],
            null,
            null,
            "close");

        //dlg.keepOpen = true;
        dlg.show()

        this.UiModder.domClass.remove(dlg.leftActionContainerNode, "w3-hide");

        form.startup();
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setup({

            "Attendance_CheckinAssociate": {
                navigationAreaName: "EmploymentAttendance_Navigation_MainTitle",
                icon: "fas fa-user-check",
                label: "EmploymentCheckin_MainTitle",
                colorClass: "w3-purple",
                roles: ["EmploymentCheckin_Associate"],
                featurepath: "OrchestraEmployment/SelfCheckin",
                targetWidget: OE_CheckinAgenda

            },


            "Attendance_List": {
                navigationAreaName: "EmploymentAttendance_Navigation_MainTitle",
                icon: "fas fa-clipboard-check",
                label: "EmploymentAttendanceList_MainTitle",
                colorClass: "w3-deep-purple",
                roles: ["OEP_AttendanceList"],
                featurepath: "OrchestraEmployment/AttendanceList",
                targetWidget: OE_AttendanceAgenda

            },



            "Attendance_CheckinTerminal": {
                navigationAreaName: "EmploymentAttendance_Navigation_MainTitle",
                icon: "fas fa-key",
                label: "OECheckinTerminal_MainTitle",
                colorClass: "w3-indigo",
                roles: ["EmploymentCheckin_Terminal"],
                featurepath: "OrchestraEmployment/CheckinTerminal",
                targetWidget: OE_CheckinTerminalAgenda

            },

            "Proposition_Musician": {
                navigationAreaName: "OrchestraEmploymentProposition_Navigation__MainTitle",
                icon: "fas fa-user-tag",
                label: "OrchestraEmploymentProposition_Label__Proposition",
                colorClass: "w3-khaki",
                roles: ["OEP_MusicianProposition"],
                featurepath: "OrchestraEmployment/MusicianProposition",
                targetWidget: OE_MusicianPropositionFinder

            },


            "Proposition_Confirmation": {
                navigationAreaName: "OrchestraEmploymentProposition_Navigation__MainTitle",
                icon: "fas fa-calendar-check",
                label: "OrchestraEmploymentProposition_Label__Confirmation",
                colorClass: "w3-yellow",
                roles: ["OEP_LeaderConfirmation"],
                featurepath: "OrchestraEmployment/PrincipalConfirmation",
                targetWidget: OE_PrincipalConfirmationFinder

            },

            "Proposition_ProjectStatus": {
                navigationAreaName: "OrchestraEmploymentProposition_Navigation__MainTitle",
                icon: "fas fa-tasks",
                label: "OrchestraEmploymentProposition_Label__Status",
                colorClass: "w3-amber",
                roles: ["OEP_EmploymentStatus"],
                featurepath: "OrchestraEmployment/ProjectStatus",
                targetWidget: OE_EmploymentStatusFinder

            }, "OpusPerformanceAgenda": {
                navigationAreaName: "OpusPerformance_Navigation_MainTitle",
                icon: "far fa-calendar-alt",
                label: "OpusPerformance__MainTitle_Agenda",
                colorClass: "w3-green",
                roles: ["OrchestraEmployment_Read"],
                featurepath: "OpusManagement/OpusPerformanceAgenda",
                targetWidget: OpusPerformanceAgenda

            },
            "OpusFinder": {
                navigationAreaName: "OpusPerformance_Navigation_MainTitle",
                icon: "fas fa-music",
                label: "OpusPerformance__MainTitle_OpusFinder",
                colorClass: "w3-dark-green",
                roles: ["Opus_Read"],
                featurepath: "OpusManagement/OpusFinder",
                targetWidget: OpusFinder

            },
            "EmploymentMatrix": {
                navigationAreaName: "OE_Disposition_Navigation__MainTitle",
                icon: "fas fa-border-none",//"fas fa-pencil-ruler",
                label: "OM__SchedulerMatrix",
                colorClass: "w3-blue",
                roles: ["OM_Matrix"],
                //featurepath: "OpusManagement/OpusPerformanceAgenda",
                //targetWidget: OrchestraMatrix,
                //target: "/Home/OM"
                callback: lang.hitch(this, this._openOMmatrix)
            }
        },
        // SORTIERUNG DER BEREICHE
        {
            ["OpusPerformance_Navigation_MainTitle"]: {
                order: 1
            },
            ["OE_Disposition_Navigation__MainTitle"]: {
                order: 90
            },
            ["OrchestraEmploymentProposition_Navigation__MainTitle"]: {
                order: 100
            },
            ["EmploymentAttendance_Navigation_MainTitle"]: {
                order: 150
            }
        }
        );
    }
}

export default mdsWidget(OE_HomeNavigation);